import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableTree = _resolveComponent("TableTree")!
  const _component_StatisticsVerticalColumnChart = _resolveComponent("StatisticsVerticalColumnChart")!
  const _component_StatisticsByTimeTabs = _resolveComponent("StatisticsByTimeTabs")!
  const _component_StatisticsTabs = _resolveComponent("StatisticsTabs")!

  return (_openBlock(), _createBlock(_component_StatisticsTabs, { title: "Количество уникальных пользователей" }, {
    "first-tab": _withCtx(() => [
      _createVNode(_component_StatisticsByTimeTabs, null, {
        "first-tab": _withCtx(() => [
          _createVNode(_component_TableTree, {
            columns: _ctx.tableConfig.columns,
            storePaths: _ctx.tableConfig.storePaths,
            pagination: _ctx.tableConfig.pagination,
            params: _ctx.filter,
            itemKey: "name"
          }, null, 8, ["columns", "storePaths", "pagination", "params"])
        ]),
        "second-tab": _withCtx(() => [
          _createVNode(_component_StatisticsVerticalColumnChart, {
            configs: _ctx.chartConfigs,
            params: _ctx.filter,
            overlapColumns: "",
            inverseOrderLegend: "",
            inverseOrderTooltip: ""
          }, null, 8, ["configs", "params"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}